import { ReportGroupBy } from 'src/WebApiController';

import {
  GROUP_BY_TO_PRIMARY_COLUMN_ID,
  GROUP_BY_TO_VISIBLE_COLUMN_IDS,
  NON_METRIC_LISTING_REPORT_TABLE_COLUMN_IDS,
} from './inventoryColumnUtils.constants';
import { ListingReportTableColumnId } from './inventoryColumnUtils.types';

export const isMetricConfigurableByGroupBy = (
  id: string,
  groupBy?: ReportGroupBy
) => {
  if (!groupBy) {
    return true;
  }

  if (GROUP_BY_TO_PRIMARY_COLUMN_ID[groupBy] === id) return true;

  if (
    !NON_METRIC_LISTING_REPORT_TABLE_COLUMN_IDS.includes(
      id as ListingReportTableColumnId
    )
  )
    return true;

  if (
    GROUP_BY_TO_VISIBLE_COLUMN_IDS[groupBy]?.includes(
      id as ListingReportTableColumnId
    )
  ) {
    return true;
  }
  return false;
};
